export const ROUTE_PATH = '/personnel/invite';

export const MALL_ADMIN_STRATEGY = 'MALL_ADMIN_STRATEGY';

export const STORE_ADMIN_STRATEGY = 'STORE_ADMIN_STRATEGY';

export { ROUTE_PATH as RETURN_PATH } from '@/features/personnelPage/consts';
